// [PURPOSE]: One-time warning toast when the loaded character has equipped
// non-proficient armor AND the enforce flag is on. Per user directive
// 2026-05-12 — the flag is default ON (Phase B / #335), but existing players
// loading a character with mid-session non-proficient armor need to know
// why their character is suddenly suffering disadvantage.
// [WHY]: Spec 1b Task 18. Companion to #335's default-flip.

import { useEffect, useRef } from 'react';
import { shouldShowNonProficientArmorBanner } from '../utils/armorProficiency';

export function useArmorProficiencyWarning(playerStats, settings, showStatus) {
  // characterIds we've already warned about this session — prevents spam
  const warnedRef = useRef(new Set());

  useEffect(() => {
    if (!playerStats?.id) return;
    if (warnedRef.current.has(playerStats.id)) return;
    if (!shouldShowNonProficientArmorBanner(playerStats, settings)) return;

    warnedRef.current.add(playerStats.id);
    showStatus(
      '⚠️ This character has non-proficient armor equipped. PHB p.144 penalties (disadvantage on STR/DEX + spellcast block) are active. Disable in Settings → Game Rules if your table prefers RAW relaxed.',
      'warning'
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playerStats?.id, playerStats?.inventory, settings?.enableArmorProficiencyPenalties]);
  // showStatus is intentionally omitted — it's a stable context function and
  // including it would cause the effect to re-run on every render in environments
  // where context is recreated. The warnedRef set provides the de-dup guarantee.
}
